import { useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import http from '../Http';
import utils from "../utils";
import ReactECharts from 'echarts-for-react';
import { DatePicker } from 'antd';
import moment from 'moment';
import * as XLSX from 'xlsx';

function Voltage(props) {
    const { t } = useTranslation();
    const { setTip, deviceInfo, date, setDate } = props;

    const chartEl = useRef(null);
    const chart = useRef(null);
    const data = useRef(null);
    const deviceInfoRef = useRef(null);

    useEffect(() => {
        deviceInfoRef.current = deviceInfo;
    }, [deviceInfo]);

    const exportToExcel = useCallback(() => {
        if (data.current == null || deviceInfoRef.current == null) {
            return;
        }

        let rs = 
        data.current.map((v) => {
            let r = {};
            r[t("DataTime")] = v['YMDH'];
            r[t("Avg")] = v['Avg']/10;
            r[t("Max")] = v['Max']/10;
            r[t("Min")] = v['Min']/10;
            return r;
        })

        const ws = XLSX.utils.json_to_sheet(rs);
        ws["!cols"] = [{wch: 21},{wch: 6},{wch: 6},{wch: 6}];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, deviceInfoRef.current.SN + '_Voltage.xlsx');
    }, [data, t]);

    const option = {
        darkMode: true,
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: '#6a7985'
                }
            },
            renderMode: "richText",
            formatter: (params) => {
                //return  `{max|${params[2].seriesName} : ${(parseFloat(params[2].data) + parseFloat(params[0].data)).toFixed(1)}}\n{min|${params[0].seriesName}: ${params[0].data}}\n{avg|${params[1].seriesName}: ${params[1].data}}`;
                return t('voltage_tooltip', {
                    max: (parseFloat(params[2].data) + parseFloat(params[0].data)).toFixed(1),
                    min: params[0].data,
                    avg: params[1].data
                });
            },
            rich: {
                max: {
                    color: "blue"
                },
                min: {
                    color: "bbb"
                },
                avg: {
                    color: "red"
                }
            }
        },
        legend: {
            data: [{
                name: t('max'),
                icon: 'circle',
                itemStyle: {
                    color: "blue",
                },
                textStyle: {
                    color: "blue",
                }
            }, {
                name: t('min'),
                icon: 'circle',
                itemStyle: {
                    color: "#bbb",
                },
                textStyle: {
                    color: "#bbb",
                }
            }, {
                name: t('avg'),
                icon: 'circle',
                itemStyle: {
                    color: "red",
                },
                textStyle: {
                    color: "red",
                }
            }],
        },
        toolbox: {
            right: 40,
            feature: {
                myDownloadXls: {
                    show: true,
                    title: t("Download"),
                    icon: "path://M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7c3.2 4.1 9.4 4.1 12.6 0l112-141.7c4.1-5.2 0.4-12.9-6.3-12.9z M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6 0.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4 14.9-19.2 32.6-35.9 52.4-49.9 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7-23.4 23.4-54.5 36.3-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z",
                    onclick: exportToExcel,
                }
            }
        },
        grid: {
            left: 40,
            right: '4%',
            bottom: 40,
            containLabel: true
        },
        xAxis: [{
            type: 'category',
            boundaryGap: false,
            data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'],
            name: t("curve_axis.hour"),
            nameLocation: "center",
            nameGap: 25,
        }],
        yAxis: [
            {
                type: 'value',
                name: t("curve_axis.voltage"),
                nameLocation: "middle",
                nameRotate: 90,
                nameGap: 40,
            }
        ],
        series: [{
            name: t("min"),
            type: 'line',
            stack: 'total',
            smooth: true,
            lineStyle: {
                width: 0
            },
            showSymbol: false,
            areaStyle: {
                opacity: 0,
            },
            emphasis: {
                focus: 'none',
            },
            data: []
        },
        {
            name: t("avg"),
            type: 'line',
            stack: '',
            smooth: true,
            lineStyle: {
                width: 1,
                color: "red"
            },
            showSymbol: false,
            areaStyle: {
                opacity: 0,
            },
            emphasis: {
                focus: 'none'
            },
            data: []
        },
        {
            name: t("max"),
            type: 'line',
            stack: 'total',
            smooth: true,
            lineStyle: {
                width: 0
            },
            showSymbol: false,
            areaStyle: {
                opacity: 0.8,
                color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                        offset: 0, color: 'blue' // 0% 处的颜色
                    }, {
                        offset: 1, color: '#bbb' // 100% 处的颜色
                    }],
                    global: false // 缺省为 false
                }
            },
            emphasis: {
                focus: 'none'
            },
            data: []
        }]
    };

    useEffect(() => {
        if(deviceInfo == null) {
            return;
        }

        let active = true;
        const ymd = utils.dateFormat("YYYY-mm-dd", date);

        (async () => {
            let resp = await http.post("report/device/voltage/daily/report", {
                "DeviceID": deviceInfo.ID,
                "DateTime": ymd
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("Report Voltage", e);
                return null;
            });

            if (!active) {
                return;
            }

            if (resp == null || resp.code != 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t('load_data_error') });

                option.series[0].data = [];
                option.series[1].data = [];
                option.series[2].data = [];
            } else {
                let ds = {};
                let maxes = [];
                let mins = [];
                let avgs = [];

                resp.data.forEach((v) => {
                    ds[v['YMDH']] = v;
                });
                for (let i = 1; i < 25; i++) {
                    var ymdh;
                    if (i == 24) {
                        var x = utils.dateFormat("YYYY-mm-dd", new Date((new Date(date)).setDate(date.getDate() + 1)));
                        ymdh = x + " " + "00:00:00";
                    } else {
                        ymdh = ymd + " " + i.toString().padStart(2, 0) + ":00:00";
                    }
                    // const ymdh = ymd+" "+i.toString().padStart(2, 0)+":00:00";
                    if (ds[ymdh]) {
                        mins.push(((ds[ymdh]["Min"]) / 10).toFixed(1));
                        avgs.push((ds[ymdh]["Max"] / 20 + ds[ymdh]["Min"] / 20).toFixed(1));
                        maxes.push((ds[ymdh]["Max"] / 10 - ds[ymdh]["Min"] / 10).toFixed(1));
                    } else {
                        mins.push(0);
                        avgs.push(0);
                        maxes.push(0);
                    }
                }
                option.series[0].data = mins;
                option.series[2].data = maxes;
                option.series[1].data = avgs;
                //console.log(maxes);

                data.current = resp.data;
            }

            //
            const instance = chart.current.getEchartsInstance();
            if (instance) {
                instance.setOption(option);
            }
        })();

        return () => {
            active = false;
        };
    }, [deviceInfo, date]);

    const handleGoPreDay = () => {
        setDate(new Date(date.setDate(date.getDate() - 1)));
    }

    const handleGoNextDay = () => {
        if (utils.dateFormat("YYYY-mm-dd", date) >= utils.dateFormat("YYYY-mm-dd", new Date())) {
            setTip({ open: true, severity: "info", msg: t('date_exceeded') });
            return;
        }

        setDate(new Date(date.setDate(date.getDate() + 1)));
    }

    return (
        <div style={{
            flex: "1 1 auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            backgroundColor: "white",
            overflow: 'auto',
            borderRadius: 10,
        }}>
            {/* <div style={{
                flex: '0 0 60px',
                display: "flex",
            }}>
                <IconButton onClick={handleGoPreDay}>
                    <NavigateBeforeIcon style={{ fontSize: 30, color: "white", }} />
                </IconButton>
                <div style={{
                    flex: '1 0 auto',
                    display: "flex",
                    justifyContent: 'center',
                    alignItems: "center",
                    color: "white",
                    fontSize: 20
                }}>
                    <DateTimePicker 
                        className={classes.calender}
                        disableClock={true}
                        value={new Date(date.getTime())}
                        format="yyyy-MM-dd"
                        maxDate={new Date()}
                        isCalendarOpen={isCalendarOpen}
                        locale="en"
                        onChange={(v) => {
                            setDate(v);
                        }}
                        onCalendarClose={() => {
                            setIsCalendarOpen(false);
                        }}
                    />
                </div>
                <IconButton onClick={handleGoNextDay}>
                    <NavigateNextIcon style={{ fontSize: 30, color: "white", }} />
                </IconButton>
            </div> */}
            <div style={{
                flex: '1 0 20px',
                display: "flex",
                justifyContent: 'center',
                alignItems: "flex-end",
                color: "white",
                fontSize: 20,
            }}>
                <DatePicker
                    locale="en"
                    onChange={(v) => {
                        setDate(v.toDate());
                    }}
                    //defaultValue={moment()}
                    value={moment(date)}
                    style={{ borderRadius: '20px' }}
                />
            </div>
            <div style={{
                flex: "1 1 auto",
                display: "flex",
                flexDirection: "column",
                alignItems: 'stretch',
                overflow: "auto",
                padding: 5,
                backgroundColor: "white",
            }}>
                <div style={{
                    flex: "1, 1 auto",
                    minWidth: 400,
                }} ref={chartEl}>
                    <ReactECharts ref={chart} option={option} style={{ height: 400 }} />
                </div>
            </div>
        </div>
    )
}

export default Voltage;